import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowHardware() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.hardware')}
      description={t('feature-description.hardware')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
